import { Button } from '~/components/ui'

export default function MapSort({
  sort,
  updateFilter,
}: {
  sort?: string
  updateFilter: (key: string, value: string) => void
}) {
  return (
    <div className="space-y-2">
      <p className="text-sm">
        Sort By
        {sort && sort !== 'modifiedD' && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => {
              updateFilter('sort', 'modifiedD')
            }}>
            (reset)
          </Button>
        )}
      </p>
      <select
        className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
        value={sort || 'modifiedD'}
        onChange={(e) => {
          updateFilter('sort', e.target.value)
        }}>
        <option value="modifiedD">Modified (newest to latest)</option>
        <option value="createdD">Created (newest to latest)</option>
        <option value="priceD">Price (highest to lowest)</option>
        <option value="priceA">Price (lowest to highest)</option>
        <option value="rateD">Lease Rate (highest to lowest)</option>
        <option value="rateA">Lease Rate (lowest to highest)</option>
        <option value="availableSfD">Available SF (highest to lowest)</option>
        <option value="availableSfA">Available SF (lowest to highest)</option>
        <option value="acresD">Acres (highest to lowest)</option>
        <option value="acresA">Acres (lowest to highest)</option>
      </select>
    </div>
  )
}
